import React from "react";
import AppStatusDot from "./AppStatusDot/AppStatusDot";
import styles from "./ChildAppCard.module.scss";
import useCommonStore from "../../../stores/common";
import useApplicationStore from "../../../stores/application";

const ChildAppCard = ({ child, organization, parentApp, isParent }) => {
  const setShowDetails = useCommonStore((state) => state.setShowDetails);
  const setActiveApp = useApplicationStore((state) => state.setActiveApp);

  const handleCardClick = () => {
    setActiveApp(child);
    setShowDetails(true);
  };

  const displayName = isParent ? child?.field_dba : (child?.bank?.name || "-");

  return (
    <div 
      className={styles.child_app_card}
      onClick={handleCardClick}
    >
      <div className={styles.card_left}>
        <div className={styles.card_content}>
          <div className={styles.dba_name}>{displayName}</div>
        </div>
      </div>
      <div className={styles.card_right}>
        <div className={styles.status_container}>
          <AppStatusDot
            progression_id={child?.lead_progression_id}
          />
        </div>
      </div>
    </div>
  );
};

export default ChildAppCard;

